function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.3259 20.65C12.3762 22.7003 15.7003 22.7003 17.7506 20.6501L17.7506 20.65L21.498 16.9026C22.1932 16.2312 22.2124 15.1233 21.541 14.4282C20.8695 13.733 19.7617 13.7137 19.0665 14.3852C19.0519 14.3992 19.0376 14.4136 19.0235 14.4282L15.7766 17.6738L15.7498 1.75C15.7498 0.783508 14.9663 0 13.9998 0C13.0333 0 12.2498 0.783508 12.2498 1.75L12.2743 17.6482L9.05315 14.427C8.35796 13.7555 7.2501 13.7748 6.57865 14.47C5.92365 15.1482 5.92365 16.2233 6.57865 16.9015L10.3259 20.65Z",
  fill: "currentColor"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.25 16.9166C25.2835 16.9166 24.5 17.7001 24.5 18.6666V24.0228C24.4993 24.286 24.2861 24.4993 24.0229 24.4999H3.97715C3.71388 24.4993 3.5006 24.286 3.5 24.0228V18.6666C3.5 17.7001 2.71649 16.9166 1.75 16.9166C0.783508 16.9166 0 17.7001 0 18.6666V24.0228C0.00257031 26.2183 1.78172 27.9974 3.97715 28H24.0228C26.2183 27.9974 27.9974 26.2183 27.9999 24.0228V18.6667C28 17.7001 27.2165 16.9166 26.25 16.9166Z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/pwa-download.3f9af54f.svg";
export { SvgComponent as ReactComponent };